import React, { useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import Header from './Header';
import ProductBox from './ProductBox';
import InfiniteScroll from 'react-infinite-scroll-component';
import debounce from 'lodash/debounce';
import { v4 as uuidv4 } from 'uuid';
import Footer from './Footer';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';
import BackButton from './BackButton';
import Searchbar from './Searchbar';
import SexyCategoryBar from './SexyCategoryBar';
import FilterBar from './FilterBar';

const MobilesPage = () => {
    const { t, i18n } = useTranslation();

    const [products, setProducts] = useState([]);
    const [search, setSearch] = useState('');
    const [filteredProducts, setFilteredProducts] = useState([]);
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);

    
    const [filters, setFilters] = useState({
        category: 'phone',
        priceRange: '',
        sortOption: '',
      });
      const [filteredPhones, setFilteredPhones] = useState([]);


        // Example: update filters when user interacts with FilterBar
  const handleFilterChange = (newFilters) => {
    setFilters(newFilters);
  };

        // Apply filter logic

        useEffect(() => {
  let filtered = [...filteredProducts];

  // Filter by price range
  if (filters.priceRange) {
    let min = 0;
    let max = Infinity;

    if (filters.priceRange.includes('-')) {
      [min, max] = filters.priceRange.split('-').map(Number);
    } else if (filters.priceRange.includes('+')) {
      min = parseFloat(filters.priceRange.replace('+', ''));
      max = Infinity;
    }

    filtered = filtered.filter((item) => {
      const price = parseFloat(item?.prices?.discounted || item?.price);
      return price >= min && price <= max;
    });
  }

  // Sort by biggest price drop
  if (filters.sortOption === 'drop') {
    filtered.sort((a, b) => {
      const dropA = (parseFloat(a?.prices?.original || a?.price) || 0) - (parseFloat(a?.prices?.discounted || a?.price) || 0);
      const dropB = (parseFloat(b?.prices?.original || b?.price) || 0) - (parseFloat(b?.prices?.discounted || b?.price) || 0);
      return dropB - dropA;
    });
  }

  setFilteredPhones(filtered);
// }, [filters, filteredProducts, search]);
}, [filters, filteredProducts]);


//   useEffect(() => {
//     let filtered = [...filteredProducts];

//     // Filter by price range
//     if (filters.priceRange) {
//       const [min, max] = filters.priceRange === '1000+'
//         ? [1000, Infinity]
//         : filters.priceRange.split('-').map(Number);
//       filtered = filtered.filter((item) => {
//         const price = parseFloat(item?.prices?.discounted || item?.price);
//         return price >= min && price <= max;
//       });
//     }

//     // Sort by biggest price drop
//     if (filters.sortOption === 'drop') {
//       filtered.sort((a, b) => {
//         const dropA = (parseFloat(a?.prices?.original || a?.price) || 0) - (parseFloat(a?.prices?.discounted || a?.price) || 0);
//         const dropB = (parseFloat(b?.prices?.original || b?.price) || 0) - (parseFloat(b?.prices?.discounted || b?.price) || 0);
//         return dropB - dropA;
//       });
//     }

//     setFilteredPhones(filtered);
//   }, [filters, filteredProducts]);
//   }, [filters, filteredProducts, search]);

    const fetchProducts = async (page, searchTerm = '') => {
        try {
            const endpoint = searchTerm ? `${process.env.REACT_APP_API_BASE_URL}/api/tech/phones/search` : `${process.env.REACT_APP_API_BASE_URL}/api/tech/phones`;
            // const response = await axios.get(endpoint, {
            //     params: {
            //         page,
            //         searchTerm // This will be ignored by the paginated endpoint
            //     },
            // });

            const response = await axios.get(endpoint, {
            params: {
                page,
                searchTerm,
                minPrice: filters.priceRange?.includes('+') ? filters.priceRange.replace('+', '') : filters.priceRange?.split('-')[0],
                maxPrice: filters.priceRange?.includes('+') ? undefined : filters.priceRange?.split('-')[1],
            },
            });

            const newProducts = response.data.products;

            const sortedProducts = newProducts.sort((a, b) => {
                const popA = a.popularityScore !== null ? a.popularityScore : 0;
                const popB = b.popularityScore !== null ? b.popularityScore : 0;

                if (popA !== popB) {
                    return popB - popA;
                }

                const priceDiffA = (a.prices.original - a.prices.discounted) || 0;
                const priceDiffB = (b.prices.original - b.prices.discounted) || 0;
                return priceDiffB - priceDiffA;
            });

            if (searchTerm) {
                setFilteredProducts((prevFilteredProducts) => {
                    if (page === 1) {
                        return sortedProducts;
                    } else {
                        return [...prevFilteredProducts, ...sortedProducts];
                    }
                });
            } else {
                setProducts((prevProducts) => {
                    if (page === 1) {
                        return sortedProducts;
                    } else {
                        return [...prevProducts, ...sortedProducts];
                    }
                });
                setFilteredProducts((prevFilteredProducts) => {
                    if (page === 1) {
                        return sortedProducts;
                    } else {
                        return [...prevFilteredProducts, ...sortedProducts];
                    }
                });
            }

            setHasMore(page < response.data.totalPages);
        } catch (error) {
            console.error('Error fetching products:', error);
        } 
    };

        // Debounce the search input
        const debouncedFetchProducts = useCallback(debounce((page, searchTerm) => {
            fetchProducts(page, searchTerm);
        }, 500), []); // Adjust the debounce delay as needed

    useEffect(() => {
        if (search.trim() === '') {
          setPage(1);
          setProducts([]);
          fetchProducts(1);
        } else {
          setPage(1);
          setHasMore(true);
          debouncedFetchProducts(1, search);
        }
    }, [search, debouncedFetchProducts]);


    useEffect(() => {
        if (page > 1) {
          fetchProducts(page, search);
        }
      }, [page, search]);


      const handleSearchChange = (e) => {
        setSearch(e.target.value);
    };
    
    return (
        <div className="container">
        <Helmet>
        <title>Phones - Latest Smartphones & Accessories | bkamho</title>
        <meta name="description" content="Explore the latest smartphones and accessories at unbeatable prices. Shop top brands now." />
        <title>الهواتف - أحدث الهواتف الذكية والاكسسوارات | bkamho</title>
        <meta name="description" content="استكشف أحدث الهواتف الذكية والاكسسوارات بأسعار لا تقبل المنافسة. تسوق الآن من أفضل العلامات التجارية." />
        <meta name="robots" content="index, follow" />
        </Helmet>
          <div className='header-menu-container'>
          <Header />
          </div>
          <SexyCategoryBar />
          <BackButton />
          <Searchbar search={search} handleSearchChange={handleSearchChange} placeholder={t('mobilesPage.searchbar')} />
          <FilterBar category="phone" onFilterChange={handleFilterChange} />
            <div className="skincare-products">
                <h1 className='text-xl pt-4 font-semibold text-[rgb(62,43,205)]'>{t('mobilesPage.title')}</h1>
                <InfiniteScroll
                    // dataLength={filteredProducts.length}
                    dataLength={filteredPhones.length}
                    next={() => setPage((prevPage) => prevPage + 1)}
                    hasMore={hasMore}
                    loader={<p>{t('general.loading')}</p>}
                    endMessage={<p>{t('general.noMoreProducts')}</p>}
                >
                <div className="product-list">
                    {/* {filteredProducts.map(product => ( */}
                         {filteredPhones.map(product => (
                        <div key={uuidv4()}>
                        <ProductBox product={product} />
                        </div>
                    ))}
                </div>
                </InfiniteScroll>
            </div>
            <Footer />
        </div>
    );
};

export default MobilesPage;
